import type { ReactNode } from "react";

export type FiltersDrawerLabels = {
  title: string;
  backButtonLabel: string;
  filterByLabel: string;
  resetLabel: string;
  showResultsLabel: string;
};

export type FiltersDrawerProps = {
  children: ReactNode;
  activeFiltersCount: number;
  resultsLabel?: string;
  labels: FiltersDrawerLabels;
  onApply: () => void;
  onReset: () => void;
  onDrawerOpen?: () => void;
};
